// @flow
import React from "react";
import { get, throttle } from "lodash";
import type { BinaryFn } from "@tvg/types/Functional";
import TVGExpandableTrack from "@tvg/tracks-builder/src/components/expandable-track";
import type { Track } from "@tvg/tracks-builder/src/TracksType/types";
import ExpandableRow from "@fdr/atomic-ui/_templates/ExpandableRow";
import TrackLineHeader from "@fdr/atomic-ui/_molecules/TrackLineHeader";

import RaceList from "../track-races";

const getTrackComponent = (
  track: Track,
  isFavorite: boolean,
  handleFavoriteChange: BinaryFn<boolean, string, void>,
  useIsPromoTagShownFlag: boolean
) => (
  <TrackLineHeader
    qaLabel={`trackLineHeader-${track.code}`}
    trackCode={track.code}
    trackName={track.name || track.shortName}
    isFavorite={isFavorite}
    hasPromo={track.hasPromo}
    hasResultedState={track.isFinished}
    handleFavoriteChange={handleFavoriteChange}
    isPromoTagShown={track.isPromoTagShown}
    useIsPromoTagShownFlag={useIsPromoTagShownFlag}
  />
);

export default class ExpandableTrack extends TVGExpandableTrack {
  localHandleFavoriteChange = throttle(
    () => {
      const isFavorite = !this.state.isFavorite;
      if (this.props.isLogged) {
        this.setState({
          isFavorite
        });
      }
      this.props
        .handleFavoriteChange(isFavorite, get(this.props, "track.code", ""))
        .catch(() => {
          this.setState({
            isFavorite: !isFavorite
          });
        });
    },
    1500,
    { trailing: false }
  );

  render() {
    return (
      // $FlowFixMe
      <ExpandableRow
        onExpand={(isOpen: boolean) => {
          const tracktype = get(this.props, "trackType", "");
          return this.props.onTrackClickHandler(
            get(this.props, "track.name", ""),
            get(this.props, "track.code", ""),
            get(this.props, "track.labels", []),
            `${tracktype[0]}${tracktype
              .slice(1)
              .replace("_", " ")
              .toLowerCase()}`,
            isOpen,
            get(this.props, "track.isGreyhound", false)
          );
        }}
        header={getTrackComponent(
          get(this, "props.track"),
          this.state.isFavorite,
          this.localHandleFavoriteChange,
          this.props.useIsPromoTagShownFlag
        )}
        isOpen={this.props.trackDropdownIsOpen(
          get(this.props, "track.code", "")
        )}
        isLastTrack={this.props.isLastTrack}
        qaLabel={`trackLineHeader-${get(this.props, "track.code", "")}`}
        fixedHeight={65}
      >
        <RaceList
          isDisplayingRaces={this.props.trackDropdownIsOpen(
            get(this.props, "track.code", "")
          )}
          trackType={this.props.trackType}
          device={this.props.device}
          idPrefix={this.props.idPrefix}
          trackCode={get(this.props, "track.code", "")}
          trackName={get(this.props, "track.name", "")}
          isFavorite={get(this.state, "isFavorite", false)}
          isGreyhoundsTrack={get(this.props, "track.isGreyhound", "")}
          shouldUpdate={this.props.trackDropdownIsOpen(
            get(this.props, "track.code", "")
          )}
          accountId={this.props.accountId}
          rdaClient={this.props.rdaClient}
          isLogged={this.props.isLogged}
          isOpen={this.props.trackDropdownIsOpen(
            get(this.props, "track.code", "")
          )}
        />
      </ExpandableRow>
    );
  }
}
